// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1q_IC","col":"styles_col__2oCdR"};